import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=2847451a&"
import script from "./SfInput.vue?vue&type=script&lang=js&"
export * from "./SfInput.vue?vue&type=script&lang=js&"
import style0 from "./SfInput.vue?vue&type=style&index=0&id=2847451a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports